import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ReactDOM from 'react-dom';
import {Nav, NavItem, UncontrolledCollapse} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import NotificationBadge from 'react-notification-badge';
import {
  setContainerClassnames,
  addContainerClassname,
  changeDefaultClassnames,
  changeSelectedMenuHasSubItems
} from '../../redux/actions';

import getMenuItems from '../../constants/menu';
import Rbac from '../../components/Rbac';



class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedParentMenu: '',
      viewingParentMenu: ''
    };
  }

  handleWindowResize = event => {
    if (event && !event.isTrusted) {
      return;
    }
    const {containerClassnames} = this.props;
    let nextClasses = this.getMenuClassesForResize(containerClassnames);
    this.props.setContainerClassnames(
      0,
      nextClasses.join(' '),
      this.props.selectedMenuHasSubItems
    );
  };

  handleDocumentClick = e => {
    const container = this.getContainer();
    let isMenuClick = false;
    if (
      e.target &&
      e.target.classList &&
      (e.target.classList.contains('menu-button') ||
        e.target.classList.contains('menu-button-mobile'))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      (e.target.parentElement.classList.contains('menu-button') ||
        e.target.parentElement.classList.contains('menu-button-mobile'))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.parentElement &&
      e.target.parentElement.parentElement.classList &&
      (e.target.parentElement.parentElement.classList.contains('menu-button') ||
        e.target.parentElement.parentElement.classList.contains(
          'menu-button-mobile'
        ))
    ) {
      isMenuClick = true;
    }
    if (container.contains(e.target) || container === e.target || isMenuClick) {
      return;
    }
    this.setState({
      viewingParentMenu: ''
    });
    this.toggle();
  };

  getMenuClassesForResize = classes => {
    const {menuHiddenBreakpoint, subHiddenBreakpoint} = this.props;
    let nextClasses = classes.split(' ').filter(x => x !== '');
    const windowWidth = window.innerWidth;
    if (windowWidth < menuHiddenBreakpoint) {
      nextClasses.push('menu-mobile');
    } else if (windowWidth < subHiddenBreakpoint) {
      nextClasses = nextClasses.filter(x => x !== 'menu-mobile');
      if (
        nextClasses.includes('menu-default') &&
        !nextClasses.includes('menu-sub-hidden')
      ) {
        nextClasses.push('menu-sub-hidden');
      }
    } else {
      nextClasses = nextClasses.filter(x => x !== 'menu-mobile');
      if (
        nextClasses.includes('menu-default') &&
        nextClasses.includes('menu-sub-hidden')
      ) {
        nextClasses = nextClasses.filter(x => x !== 'menu-sub-hidden');
      }
    }
    return nextClasses;
  };

  getContainer = () => {
    // eslint-disable-next-line react/no-find-dom-node
    return ReactDOM.findDOMNode(this);
  };

  toggle = () => {
    const hasSubItems = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubItems);
    const {containerClassnames, menuClickCount} = this.props;
    const currentClasses = containerClassnames
      ? containerClassnames.split(' ').filter(x => x !== '')
      : '';
    let clickIndex = -1;

    if (!hasSubItems) {
      if (
        currentClasses.includes('menu-default') &&
        (menuClickCount % 4 === 0 || menuClickCount % 4 === 3)
      ) {
        clickIndex = 1;
      } else if (
        currentClasses.includes('menu-sub-hidden') &&
        (menuClickCount === 2 || menuClickCount === 3)
      ) {
        clickIndex = 0;
      } else if (
        currentClasses.includes('menu-hidden') ||
        currentClasses.includes('menu-mobile')
      ) {
        clickIndex = 0;
      }
    } else {
      if (currentClasses.includes('menu-sub-hidden') && menuClickCount === 3) {
        clickIndex = 2;
      } else if (
        currentClasses.includes('menu-hidden') ||
        currentClasses.includes('menu-mobile')
      ) {
        clickIndex = 0;
      }
    }
    if (clickIndex >= 0) {
      this.props.setContainerClassnames(
        clickIndex,
        containerClassnames,
        hasSubItems
      );
    }
  };

  handleProps = () => {
    this.addEvents();
  };

  addEvents = () => {
    ['click', 'touchstart', 'touchend'].forEach(event =>
      document.addEventListener(event, this.handleDocumentClick, true)
    );
  };

  removeEvents = () => {
    ['click', 'touchstart', 'touchend'].forEach(event =>
      document.removeEventListener(event, this.handleDocumentClick, true)
    );
  };

  setSelectedLiActive = callback => {
    const menuItems = getMenuItems(this.props.statistics);
    const oldli = document.querySelector('.sub-menu  li.active');
    if (oldli != null) {
      oldli.classList.remove('active');
    }

    /* set selected parent menu */
    const selectedlink = document.querySelector('.sub-menu  a.active');
    if (selectedlink != null) {
      selectedlink.parentElement.classList.add('active');
      this.setState(
        {
          selectedParentMenu: selectedlink.parentElement.parentElement.getAttribute(
            'data-parent'
          )
        },
        callback
      );
    } else {
      var selectedParentNoSubItem = document.querySelector(
        '.main-menu  li a.active'
      );
      if (selectedParentNoSubItem != null) {
        this.setState(
          {
            selectedParentMenu: selectedParentNoSubItem.getAttribute(
              'data-flag'
            )
          },
          callback
        );
      } else if (this.state.selectedParentMenu === '') {
        this.setState(
          {
            selectedParentMenu: menuItems[0].id
          },
          callback
        );
      }
    }
  };

  setHasSubItemStatus = () => {
    const hasSubmenu = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubmenu);
    this.toggle();
  };

  getIsHasSubItem = () => {
    const menuItems = getMenuItems(this.props.statistics);
    const {selectedParentMenu} = this.state;
    const menuItem = menuItems.find(x => x.id === selectedParentMenu);
    if (menuItem)
      return !!(menuItem && menuItem.subs && menuItem.subs.length > 0);
    else return false;
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setSelectedLiActive(this.setHasSubItemStatus);

      window.scrollTo(0, 0);
    }
    this.handleProps();
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
    this.handleProps();
    this.setSelectedLiActive(this.setHasSubItemStatus);
  }

  componentWillUnmount() {
    this.removeEvents();
    window.removeEventListener('resize', this.handleWindowResize);
  }

  openSubMenu = (e, menuItem) => {
    const selectedParent = menuItem.id;
    const hasSubMenu = menuItem.subs && menuItem.subs.length > 0;
    this.props.changeSelectedMenuHasSubItems(hasSubMenu);
    if (!hasSubMenu) {
      this.setState({
        viewingParentMenu: selectedParent,
        selectedParentMenu: selectedParent
      });
      this.toggle();
    } else {
      e.preventDefault();

      const {containerClassnames, menuClickCount} = this.props;
      const currentClasses = containerClassnames
        ? containerClassnames.split(' ').filter(x => x !== '')
        : '';

      if (!currentClasses.includes('menu-mobile')) {
        if (
          currentClasses.includes('menu-sub-hidden') &&
          (menuClickCount === 2 || menuClickCount === 0)
        ) {
          this.props.setContainerClassnames(3, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes('menu-hidden') &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          this.props.setContainerClassnames(2, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes('menu-default') &&
          !currentClasses.includes('menu-sub-hidden') &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          this.props.setContainerClassnames(0, containerClassnames, hasSubMenu);
        }
      } else {
        this.props.addContainerClassname(
          'sub-show-temporary',
          containerClassnames
        );
      }
      this.setState({
        viewingParentMenu: selectedParent
      });
    }
  };

  render() {
    const {t, statistics} = this.props;
    const {selectedParentMenu, viewingParentMenu} = this.state;
    const menuItems = getMenuItems(statistics);
    return (
      <div className="sidebar">
        <div className="main-menu">
          <div className="scroll">
            <PerfectScrollbar
              option={{suppressScrollX: true, wheelPropagation: false}}
            >
              <Nav vertical className="list-unstyled">
                {menuItems &&
                menuItems.filter(item => typeof item.show === "undefined" || item.show).map(item => {
                  return (
                    item.subs && item.subs.filter(item => typeof item.show === "undefined" || item.show).map(sub => sub.permission).some(x => Rbac.hasPermission(x))
                      ?
                        <NavItem
                          key={item.id}
                          className={classnames({
                            active:
                              (selectedParentMenu === item.id &&
                                viewingParentMenu === '') ||
                              viewingParentMenu === item.id
                          })}
                        >
                          {item.newWindow ? (
                            <a
                              href={item.to}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              {item.icon && <span>
                                {item.icon.split(' ').map(icon => <i key={icon} className={icon}/> )}
                              </span>}{' '}
                              {t(item.label)}
                            </a>
                          ) : (
                            <NavLink
                              to={item.to}
                              onMouseEnter={item.subs[0].label ?
                                e => {
                                  const {menuHiddenBreakpoint} = this.props;
                                  const windowWidth = window.innerWidth;
                                  if (windowWidth >= menuHiddenBreakpoint) {
                                    this.openSubMenu(e, item);
                                  }
                                } : window.innerWidth >= this.props.menuHiddenBreakpoint ?
                                  this.toggle : null
                              }
                              onClick={item.subs[0].label ?
                                e => {
                                  const {menuHiddenBreakpoint} = this.props;
                                  const windowWidth = window.innerWidth;
                                  if (windowWidth >= menuHiddenBreakpoint) {
                                    this.props.history.push(item.to);
                                    // setTimeout(() => {this.openSubMenu(e, item);}, 0);
                                  } else {
                                    this.openSubMenu(e, item);
                                  }
                                } : null
                              }
                              data-flag={item.id}
                            >
                              {item.icon && <span>
                                {item.icon.split(' ').map(icon => <i key={icon} className={icon}/> )}
                              </span>}
                              {' '}
                              {t(item.label)}
                              {!!item.count && <span className='sidebar-badge'>
                                <NotificationBadge className='bg-primary' count={item.count}/>
                              </span>}
                            </NavLink>
                          )}
                        </NavItem> : null
                  );
                })}
              </Nav>
            </PerfectScrollbar>
          </div>
        </div>

        <div className="sub-menu" onMouseLeave={window.innerWidth >= this.props.menuHiddenBreakpoint ? this.toggle : null}>
          <div className="scroll">
            <PerfectScrollbar
              option={{suppressScrollX: true, wheelPropagation: false}}
            >
              {menuItems &&
              menuItems.filter(item => typeof item.show === "undefined" || item.show).map(item => {
                return (
                  <Nav
                    key={item.id}
                    className={classnames({
                      'd-block':
                        (this.state.selectedParentMenu === item.id &&
                          this.state.viewingParentMenu === '') ||
                        this.state.viewingParentMenu === item.id
                    })}
                    data-parent={item.id}
                  >
                    {item.subs &&
                    item.subs.filter(item => typeof item.show === "undefined" || item.show).map((sub, index) => {
                      return (
                        <Rbac permission={sub.permission} key={index}>
                          <NavItem key={`${item.id}_${index}`}>
                            {sub.newWindow ? (
                              <a
                                href={sub.to}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                {sub.icon && <span>
                                {sub.icon.split(' ').map(icon => <i key={icon} className={icon}/> )}
                              </span>}{' '}
                                {t(sub.label)}
                              </a>
                            ) : sub.subs && sub.subs.length > 0 ? (
                              <Fragment>
                                <NavLink
                                  to={sub.to}
                                  id={`${item.id}_${index}`}
                                >
                                  <div className='d-flex flex-row align-items-center justify-content-between'>
                                    {sub.icon && <span>
                                      {sub.icon.split(' ').map(icon => <i key={icon} className={icon}/> )}
                                    </span>}{' '}
                                    {t(sub.label)}
                                    <i className='icon-Arrow-Down'/></div>
                                </NavLink>

                                <UncontrolledCollapse
                                  toggler={`#${item.id}_${index}`}
                                >
                                  <Nav className="third-level-menu mt-2">
                                    {sub.subs.map((thirdSub, thirdIndex) => {
                                      return (
                                        <Rbac
                                          permission={thirdSub.permission}
                                          key={`${
                                            item.id
                                          }_${index}_${thirdIndex}`}
                                        >
                                          <NavItem>
                                            {thirdSub.newWindow ? (
                                              <a
                                                href={thirdSub.to}
                                                rel="noopener noreferrer"
                                                target="_blank"
                                              >
                                                {thirdSub.icon && <span>
                                              {thirdSub.icon.split(' ').map(icon => <i key={icon} className={icon}/> )}
                                            </span>}{' '}
                                                {t(thirdSub.label)}
                                              </a>
                                            ) : (
                                              <NavLink to={thirdSub.to}>
                                                <div className='d-flex flex-row justify-content-between align-items-center'>
                                                <span>
                                                  {thirdSub.icon && <span>
                                                  {thirdSub.icon.split(' ').map(icon => <i key={icon} className={icon}/> )}
                                                  </span>}{' '}
                                                  {t(thirdSub.label)}
                                                </span>
                                                  {!!thirdSub.count && <span className='sidebar-sub-badge'>
                                                  <NotificationBadge className='bg-primary' count={thirdSub.count}/>
                                                </span>}
                                                </div>
                                              </NavLink>
                                            )}
                                          </NavItem>
                                        </Rbac>
                                      );
                                    })}
                                  </Nav>
                                </UncontrolledCollapse>
                              </Fragment>
                            ) : (
                              <NavLink to={sub.to}>
                                <div className='d-flex flex-row justify-content-between align-items-center'>
                                  <span>
                                    {sub.icon && <span>
                                      {sub.icon.split(' ').map(icon => <i key={icon} className={icon}/> )}
                                    </span>}{' '}
                                    {t(sub.label)}
                                  </span>
                                  {!!sub.count && <span className='sidebar-sub-badge'>
                                    <NotificationBadge className='bg-primary' count={sub.count}/>
                                  </span>}
                                </div>
                              </NavLink>
                            )}
                          </NavItem>
                        </Rbac>
                      );
                    })}
                  </Nav>
                );
              })}
            </PerfectScrollbar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({menu, app}) => {
  const {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
  } = menu;
  return {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
    statistics: app.statistics,
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    {
      setContainerClassnames,
      addContainerClassname,
      changeDefaultClassnames,
      changeSelectedMenuHasSubItems
    }
  )(withTranslation()(Sidebar))
);
